import React from 'react';
import { FaInstagram, FaYoutube, FaWhatsapp, FaFacebook } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-[#292929] text-[#FAFAFA] py-4 text-center">
      <div className="container mx-auto px-4">
        <div className="flex justify-center gap-6 mb-4">
          <a
            href="https://www.instagram.com/new_brindha_studio_?igsh=MXE3ODRwZmJveHdsaw=="
            target="_blank"
            rel="noopener noreferrer"
            className="text-2xl text-gray-200 hover:text-pink-500 transition-colors duration-300"
            aria-label="Instagram"
          >
            <FaInstagram />
          </a>
          <a
            href="https://www.youtube.com/@NewBrindhaphotography"
            target="_blank"
            rel="noopener noreferrer"
            className="text-2xl text-gray-200 hover:text-red-600 transition-colors duration-300"
            aria-label="YouTube"
          >
            <FaYoutube />
          </a>
          <a
            href="https://wa.me/+919698995997"
            target="_blank"
            rel="noopener noreferrer"
            className="text-2xl text-gray-200 hover:text-green-500 transition-colors duration-300"
            aria-label="WhatsApp"
          >
            <FaWhatsapp />
          </a>
          <a
            href="https://www.facebook.com/newbrindhaphotography"
            target="_blank"
            rel="noopener noreferrer"
            className="text-2xl text-gray-200 hover:text-blue-600 transition-colors duration-300"
            aria-label="Facebook"
          >
            <FaFacebook />
          </a>
        </div>
        <p className='text-gray-200'>© www.newbrindha.com. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;